import { Link } from 'react-router-dom';
import { t } from '../hooks/useT';

/** Editorial excerpt always visible on homepage (connected or not). */
export function LandingIntro() {
  return (
    <section className="landing-intro" aria-labelledby="landing-intro-title">
      <h2 id="landing-intro-title" className="landing-intro-title">{t('landing.introTitle')}</h2>
      <p className="landing-intro-text">{t('landing.introExcerpt')}</p>
      <nav className="landing-intro-links" aria-label={t('landing.introNav')}>
        <Link to="/decouvrir">{t('nav.discover')}</Link>
        <Link to="/comment-jouer">{t('nav.howToPlay')}</Link>
      </nav>
    </section>
  );
}
